<div class="request-pass">
  <div class="request-pass__wrapper">
    <div class="request-pass__container">
      <div class="request-pass__left">
        @if (!showSuccessMessage && !showErrorMessage) {
          <p>
            Enter your email address and we’ll send a link to reset your password
          </p>
        }

        @if (showErrorMessage) {
          <div class="evta-alert evta-alert-danger" role="alert">
            <p class="alert-title">
              <b>{{ requestPasswordActionMessage }}</b>
            </p>
          </div>
        }

        @if (showSuccessMessage) {
          <div class="evta-alert evta-alert-success" role="alert">
            <p class="alert-title">
              <b>{{ requestPasswordActionMessage }}</b>
            </p>
          </div>
        }

        @if (!showSuccessMessage && !showErrorMessage) {
          <form
            (ngSubmit)="requestPass(form)"
            #form="ngForm"
            aria-labelledby="title"
            class="form"
            >
            <div class="form-group template full-width">
              <div
                id="mobile-no"
                class="e-float-input"
                [ngClass]="{ 'e-success': email.valid }"
                >
                <input
                  type="text"
                  id="email"
                  name="email"
                  [(ngModel)]="emailAddress"
                  #email="ngModel"
                  required
                  />
                <span class="e-float-line"></span>
                <label
                  class="e-float-text"
                [ngClass]="{
                  'e-label-top': email !== '',
                  'e-label-bottom': email == ''
                }"
                  for="name"
                  >Email</label
                  >
                </div>
                @if (
                  email.errors &&
                  email.errors.required &&
                  (email.dirty || email.touched)
                  ) {
                  <span
                    class="e-error"
                    >
                    Enter your email address
                  </span>
                }
                @if (
                  !validateEmail(emailAddress) && (email.dirty || email.touched)
                  ) {
                  <span
                    class="e-error"
                    >
                    Enter a valid email address
                  </span>
                }
              </div>
              <div class="form-group template center">
                <div class="submitBtn">
                  <button
                    style="width: 12.5rem"
                    class="submit-btn e-btn"
                    id="submit-btn"
                    ejs-progressbutton
                    content="Request Password"
                    [enableProgress]="true"
                    [spinSettings]="spinCenter"
                    [animationSettings]="slideRight"
                    cssClass="e-outline e-success"
                    type="submit"
                [disabled]="
                  submitted || !form.valid || !validateEmail(emailAddress)
                "
                    >
                    Request Password
                  </button>
                </div>
              </div>
            </form>
          }
        </div>

        <div class="request-pass__right">
          <section class="info-msg" aria-label="Register">
            <div class="info-msg__step">
              To register your organization to use easyVTA please
              <a class="login-link" routerLink="../register">click here.</a>
            </div>

            <div class="info-msg__step">
              If you have been invited to join easyVTA by your organization,
              please refer to your invitation email.
            </div>

            <div class="info-msg__step">
              If you have already accepted an invitation from your organization
              and have set up your account, please log in
              <a class="login-link" routerLink="../login">here.</a>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
